import React from 'react';
import './TodoBrand.css';

function TodoBrand() {
  return (
    <header className='header'>
      <h1>What are you gonna do?</h1>
    </header>
  );
}

export { TodoBrand };
